import React, { useCallback } from 'react';
import { useFormat } from '@loomstateorg/shared-frontend/hooks/useFormat';
import { Address } from '@loomstateorg/shared-frontend/types/account';

interface Props {
  address: Address;
  onClick?: (address: Address) => void;
  index?: number;
}

const SearchItemAddress: React.FC<Props> = ({ address, onClick, index = 0 }) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const handleClick = useCallback((selected: any) => {
    onClick?.(selected);
  }, []);

  return (
    <div
      data-component-group="text-container"
      className="mx-10 mt-10 border border-neutral-400 bg-site"
      data-testid={`atom-search-address-item-${index}`}
    >
      <div className="flex cursor-pointer items-center justify-between px-10 py-5">
        <div className="flex items-center gap-16">
          <div>
            <p className="text-14" data-testid={`atom-search-address-item-name-${index}`}>
              {address?.firstName} {address?.lastName ? ' ' + address?.lastName : ''}{' '}
              {address?.storeCode ? ' - ' + address?.storeCode : ''}{' '}
              {address?.regionCode ? ' - ' + address?.regionCode : ''}
            </p>
            <p className="mt-4 font-primaryThin text-14">
              {[address?.streetName, address?.additionalStreetInfo, address?.city, `${address?.state} ${address?.postalCode}`, address?.country].filter(Boolean).join(', ')}
            </p>
          </div>
        </div>

        <span className="text-14">
          <button
            type="button"
            title={formatMessage({ id: 'select', defaultMessage: 'Select' })}
            className={`shrink-0 px-16 py-10 underline transition`}
            onClick={() => handleClick(address)}
            data-testid={`atom-search-address-item-select-${index}`}
          >
            {formatMessage({ id: 'select', defaultMessage: 'Select' })}
          </button>
        </span>
      </div>
    </div>
  );
};

export default SearchItemAddress;
